import React from 'react'
import styles from './Footer.module.css'

export default function Footer() {
  return (
    <div className={styles.bgBlue}>
      <p>© Sam Johnston, 2020</p>
    </div>
  )
}
